import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SearchCurrentQueryService extends BehaviorSubject<string> {
  constructor() {
    super('');
  }

  get query$(): Observable<string> {
    return this.asObservable();
  }

  get query(): string {
    return this.value;
  }

  setCurrentQuery(query: string): void {
    this.next(query);
  }
}
